var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advertising-modal-advanced-config-captive-forms-filter-table',{attrs:{"captive-forms-list":_vm.list,"loading":_vm.loading,"value":_vm.value},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }